import api from './client'

export interface BookmarkFolder {
  folder_id: string
  user_id: string
  name: string
  color?: string | null
  created_at: string
  bookmark_count?: number
}

export interface Bookmark {
  bookmark_id: string
  user_id: string
  pmcid: string
  title?: string | null
  folder_id?: string | null
  created_at: string
}

export const bookmarkApi = {
  listIds: () => api.get<{ pmcids: string[] }>('/bookmarks/ids').then(r => r.data.pmcids),

  listBookmarks: (folderId?: string | null) => {
    const params: any = {}
    if (folderId !== undefined && folderId !== null) params.folder_id = folderId
    return api.get<Bookmark[]>('/bookmarks', { params }).then(r => r.data)
  },

  addBookmark: (pmcid: string, title?: string | null, folderId?: string | null, corpusId?: string | null) =>
    api.post<Bookmark>('/bookmarks', { pmcid, title: title ?? null, folder_id: folderId ?? null, corpus_id: corpusId ?? null }).then(r => r.data),

  removeBookmark: (pmcid: string) =>
    api.delete(`/bookmarks/${encodeURIComponent(pmcid)}`).then(r => r.data),

  moveBookmark: (pmcid: string, folderId: string | null) =>
    api.patch<Bookmark>(`/bookmarks/${encodeURIComponent(pmcid)}`, { folder_id: folderId }).then(r => r.data),

  listFolders: () => api.get<BookmarkFolder[]>('/bookmarks/folders').then(r => r.data),

  createFolder: (data: { name: string; color?: string | null }) =>
    api.post<BookmarkFolder>('/bookmarks/folders', data).then(r => r.data),

  updateFolder: (folderId: string, data: { name?: string; color?: string | null }) =>
    api.patch<BookmarkFolder>(`/bookmarks/folders/${folderId}`, data).then(r => r.data),

  deleteFolder: (folderId: string) =>
    api.delete(`/bookmarks/folders/${folderId}`).then(r => r.data),
}
